<app-loading *ngIf="showLoading"></app-loading>

<div class="personal-main-container" [class.show]="show">
  <div class="personal-main-nav-bar box">
    <div class="personal-main-nav-bar-title">افزودن غذا به پکیج</div>
    <div class="personal-main-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="personal-main-top box">
    <div class="search-box">
      <img src="assets/general/search-blue.svg" />
      <input
        type="text"
        (ngModelChange)="search($event)"
        [(ngModel)]="searchText"
        autocomplete="off"
        placeholder="جستجو"
        autofocus
      />
    </div>
    <div class="result-box" *ngIf="searchedFoods && searchedFoods.length > 0">
      <div
        class="result-item"
        (click)="openFood(food._id)"
        *ngFor="let food of searchedFoods"
      >
        <p>{{ food.name }}</p>
        <img src="assets/general/left-blue.svg" />
      </div>
    </div>

    <p
      *ngIf="isEmpty"
      style="
        text-align: center;
        color: rgb(102, 102, 102);
        position: absolute;
        top: 20%;
        width: 100%;
      "
    >
      غذای مورد نظر پیدا نشد .
    </p>
  </div>
</div>
